export let mentionedLabel = "rx4eo";
export let repliedLabel = "NoaDQe";
export let forwardedLabel = "qGDqje";
export default {mentionedLabel,repliedLabel,forwardedLabel};